<template>
  <div>
    <Checkout/>
  </div>
</template>

<script>


import Checkout from "@/Checkout";
export default {
  components: {Checkout}
}
</script>

